<div class="minclt-dialog">
    <div class="px-3"
        *ngIf="!!dynamicDialogConfig.data?.tableroInformativo && dynamicDialogConfig.data.tableroInformativo.length > 0 ">
        <app-tablero-informativo [dataIndicators]="dynamicDialogConfig.data.tableroInformativo" />
    </div>

    <div class="minclt-border py-4">
        <app-form-print-two [questions]="questions" [textButtonSubmit]="dynamicDialogConfig.data.textForm"
            [hideAlertToSubmit]="dynamicDialogConfig.data.hideAlert" [showButtonsSubmit]="false"
            (validFormPrint)="onValidFormChange('a', $event)" (cancelQuestions)="dynamicDialogRef.close()"
            #formPrintTwo />
    </div>

    <div class="px-3 py-3">
        <ng-container *ngIf="canRequestModification">
            <div class="flex gap-2 justify-content-end">
                <ng-container *ngIf="showModalBtnEdit">
                    <p-button label="Radicar solicitud de edición" styleClass="amarillo" (click)="onClickEdit()" />
                </ng-container>
                <div *ngIf="showModalButtons" class="flex gap-2">
                    <p-button label="Cancelar" styleClass="morado" (click)="onCancel()" />
                    <p-button [label]="'Enviar a revisión'" (click)="onSubmit()" styleClass="verde"
                        [disabled]="!btnIsDisabled" />
                </div>
            </div>
        </ng-container>
        <div *ngIf="(typeOfAction === 'add' ? canCreate : canEdit) && !canRequestModification" class="flex gap-2"
            [ngClass]="{
                ' justify-content-between': showModalBtnEdit, 
                ' justify-content-end': !showModalBtnEdit, 
            }">
            <ng-container *ngIf="showModalBtnEdit">
                <p-button label="Editar" styleClass="amarillo" (click)="onClickEdit()" />
            </ng-container>
            <div *ngIf="showModalButtons" class="flex gap-2">
                <p-button label="Cancelar" styleClass="morado" (click)="onCancel()" />
                <p-button [label]="dynamicDialogConfig.data.textForm" (click)="onSubmit()" styleClass="verde"
                    [disabled]="!btnIsDisabled" />
            </div>
        </div>
    </div>
</div>